// 🆕 16/07/2026 — Helper universale per copia negli appunti con toast di conferma
import { toast } from "sonner";

export function copyToClipboard(value, label = "Testo") {
  const text = String(value || "");
  if (!text) return;
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    toast.success(`${label} copiato negli appunti ✓`);
  } catch {
    toast.error(`Impossibile copiare ${label.toLowerCase()}`);
  }
}
